<template>
    <div class="project-report card">
        <div v-if="report" class="card-body">
            <h4>{{ project.name }}</h4>
            <div><strong>GOAL:</strong> {{ theme.name }}</div>
            <div><strong>LEARNING PATH:</strong> {{ learning_path?.name ?? 'UNKNOWN' }}</div>
            <table class="table mt-3">
                <tr v-for="(team, idx) in teams">
                    <th>{{ team.name }}</th>
                    <td v-for="cu in canvasUploads(team)">
                        <strong class="block" v-if="idx === 0">{{ cu.stage.name }}</strong>
                        <div>
                            {{ cu.uploads.sections.reduce((p, c) => p + c.uploads?.length ?? 0, 0) }} uploads for
                            {{ cu.uploads.sections.reduce((p, c) => p + c.activity?.activities?.length ?? 0, 0) }} activities
                        </div>
                        <div v-if="cu.uploads.deliverable" class="text-success">
                            <icon-check class="mr-2" size="16" color="dark"/>
                            <strong class="text-sm">STAGE COMPLETE</strong>
                        </div>
<!--                        <pre>{{ cu }}</pre>-->
                    </td>
                </tr>
            </table>
        </div>
        <div v-else-if="is_busy" class="card-body">
            <placeholder style="height: 1.8rem" class="mb-2"/>
            <placeholder class="mb-1 w-50"/>
            <placeholder class="mb-1 w-25"/>
            <placeholder class="mb-1 w-75"/>
        </div>
    </div>
</template>

<script>
import API from "@/API";
import themes from "@/DATA/themes";
import Placeholder from "@/Others/Placeholders/Placeholder";
import IconCheck from "@/Icons/IconCheck";

export default {
    name: "ProjectReport",
    components: {IconCheck, Placeholder},
    props: {
        projectId: {
            type: Number,
            default: null,
        }
    },

    data() {
        return {
            is_busy: true,
            report: null,
        }
    },

    computed: {
        project(){
            return this.report?.project ?? null;
        },
        theme(){
            return themes.reduce((prev, val) => val.id == this.project?.theme ? val : prev, {id: 0, name: 'Unknown', slug: 'unknown'});
        },
        learning_path(){
            return this.project?.learning_path ?? null;
        },
        teams(){
            return this.project?.teams ?? [];
        },
        canvases(){
            return this.project?.canvases ?? [];
        },
        _$$path(){
            return this.fragmentData(this.learning_path.fragments);
        },
    },

    methods: {
        async fetch(){
            this.report = await API.projects.report(this.projectId);
            this.is_busy = false;
        },

        fragmentData(fragments){
            const fgmts = {};
            fragments.map((f) => (fgmts[f.type] = f.data));
            return fgmts;
        },

        canvasElements(team){

        },

        canvas(team){
            return this.canvases.find(( c => c.team_id === team.id ));
        },

        _$$canvas( team ){
            return this.fragmentData(this.canvas( team ).fragments);
        },

        stages(){
            return this._$$path?.stages ?? [];
        },

        stageConfig(stage_name){
            return this._$$path[`stage_${stage_name}_config`] ?? null;
        },

        pathStageActivitySections(stage_name){
            return this._$$path[`stage_${stage_name}_activity_sections`] ?? [];
        },

        pathStageActivities(stage_name){
            const activities = [];
            this.pathStageActivitySections( stage_name ).map( s => activities.push({
                section: s,
                activities: this._$$path[`stage_intro_combined_activities_${s.id}`],
            }));
            return activities;
        },

        stageCanvasUploads(team, stage_name){
            const canvas = this._$$canvas( team );
            const uploads = {
                sections: [],
                deliverable: canvas[`stage_${stage_name}_mission_deliverable`] ?? null,
            };

            const activities = this.pathStageActivities(stage_name);

            activities.map(activity => {
                const upload = canvas[`canvas_upload_${stage_name}_${activity.section.id}`] ?? null;
                // if( !upload ) return;
                uploads.sections.push({
                    activity,
                    uploads: upload,
                });
            });

            return uploads;
        },

        canvasUploads(team){
            const stages = this.stages();
            const uploads = [];
            for( let i = 0; i < stages.length; i++ ){
                const stage_name = stages[ i ];
                uploads.push({
                   stage: {id: stage_name, ...this.stageConfig(stage_name)},
                   uploads: this.stageCanvasUploads( team, stage_name ),
                });
            }
            return uploads;
        }

    },

    async mounted() {
        await this.fetch();
    }

}
</script>

<style scoped>

</style>
